var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9974 3.75342C11.8957 3.75342 3.66406 11.9851 3.66406 22.0868C3.66406 32.1884 11.8957 40.4201 21.9974 40.4201C32.0991 40.4201 40.3307 32.1884 40.3307 22.0868C40.3307 11.9851 32.0991 3.75342 21.9974 3.75342ZM29.9724 28.6318C29.7157 29.0717 29.2574 29.3101 28.7807 29.3101C28.5424 29.3101 28.3041 29.2551 28.0841 29.1084L22.4007 25.7167C20.9891 24.8734 19.9441 23.0217 19.9441 21.3901V13.8734C19.9441 13.1218 20.5674 12.4984 21.3191 12.4984C22.0707 12.4984 22.6941 13.1218 22.6941 13.8734V21.3901C22.6941 22.0501 23.2441 23.0217 23.8124 23.3517L29.4957 26.7434C30.1557 27.1284 30.3757 27.9718 29.9724 28.6318Z",
    fill: "#4CA8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock11);
export default __webpack_public_path__ + "static/media/clock11.067c5cac57d3fc8a6ad03472bc83b49e.svg";
export { ForwardRef as ReactComponent };